module.exports = __webpack_public_path__ + "assets/01.9f6fc247.pdf";